import React, { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { Drawer, IconButton, List, ListItem, ListItemText } from '@mui/material';
import MenuIcon from '@mui/icons-material/Menu';
import './Navbar.css';
import logo from '../assets/NM header.png';

const Navbar = () => {
  const [drawerOpen, setDrawerOpen] = useState(false);
  const location = useLocation();

  const handleDrawerToggle = () => {
    setDrawerOpen(!drawerOpen);
  };

  return (
    <nav className="navbar">
      <IconButton
        edge="start"
        color="inherit"
        aria-label="menu"
        onClick={handleDrawerToggle}
        className="menu-icon"
      >
        <MenuIcon style={{ color: 'white' }} />
      </IconButton>
      <div className="navbar-logo">
        <a href="https://orders.nipponfz.com">
          <img src={logo} alt="Nippon Motors Logo" className="navbar-logo-image" />
        </a>
      </div>
      <div className="navbar-container">
        <ul className="navbar-links">
          <li><a href="https://orders.nipponfz.com" className={location.pathname === '/' ? 'active' : ''}>Home</a></li>
          <li><a href="https://orders.nipponfz.com/about" className={location.pathname === '/about' ? 'active' : ''}>About Us</a></li>
          <li><a href="https://orders.nipponfz.com/news" className={location.pathname === '/news' ? 'active' : ''}>News</a></li>
          <li><a href="https://orders.nipponfz.com/search" className={location.pathname === '/search' ? 'active' : ''}>Product List</a></li>
          <li><a href="https://orders.nipponfz.com/gallery" className={location.pathname === '/gallery' ? 'active' : ''}>Gallery</a></li>
          <li><a href="https://orders.nipponfz.com/contact" className={location.pathname === '/contact' ? 'active' : ''}>Contact</a></li>
          <li>
            <Link
              to="/"
              className={location.pathname.startsWith('/') ? 'active' : ''}
              onClick={(e) => {
                if (location.pathname === '/') {
                  e.preventDefault(); // stop regular navigation
                  window.location.reload(); // force reload
                }
              }}
            >
              Catalog
            </Link>
          </li>

        </ul>
      </div>
      <Drawer anchor="left" open={drawerOpen} onClose={handleDrawerToggle} className="drawer">
        <List className="drawer-list">
          <ListItem button component="a" href="https://orders.nipponfz.com" onClick={handleDrawerToggle} className="drawer-list-item">
            <ListItemText primary="Home" />
          </ListItem>
          <ListItem button component="a" href="https://orders.nipponfz.com/about" onClick={handleDrawerToggle} className="drawer-list-item">
            <ListItemText primary="About Us" />
          </ListItem>
          <ListItem button component="a" href="https://orders.nipponfz.com/news" onClick={handleDrawerToggle} className="drawer-list-item">
            <ListItemText primary="News" />
          </ListItem>
          <ListItem button component="a" href="https://orders.nipponfz.com/search" onClick={handleDrawerToggle} className="drawer-list-item">
            <ListItemText primary="Product List" />
          </ListItem>
          <ListItem button component="a" href="https://orders.nipponfz.com/gallery" onClick={handleDrawerToggle} className="drawer-list-item">
            <ListItemText primary="Gallery" />
          </ListItem>
          <ListItem button component="a" href="https://orders.nipponfz.com/contact" onClick={handleDrawerToggle} className="drawer-list-item">
            <ListItemText primary="Contact" />
          </ListItem>
          <ListItem button component={Link} to="/" onClick={handleDrawerToggle} className="drawer-list-item">
            <ListItemText primary="Catalog" />
          </ListItem>
        </List>
      </Drawer>
    </nav>
  );
};

export default Navbar;
